/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import moment from 'moment';
import _ from 'lodash';
import WyUtils from './wy-utils.js';
import WyConstants from './wy-constants.js';

const WyFilter = {
  MODE_DATE_A: 'MODE_DATE_A',
  //MODE_DATE_B: 'MODE_DATE_B',
  //MODE_DATE_BOTH: 'MODE_DATE_BOTH',
  MODE_CALENDAR_A: 'MODE_CALENDAR_A',
  MODE_CALENDAR_B: 'MODE_CALENDAR_B',

  compareValues(value1, value2) {
    if(value1 == null) return true;
    if(value1 != null && value2 == null) return false;

    if(typeof value1 === 'object' && Array.isArray(value1)) {
      //if(value1.length == 0 || _.isEqual(_.sortBy(value1), _.sortBy(value2))) { // checking if two arrays are equal
      if(_.isEqual(_.sortBy(value1), _.sortBy(value2))) { // checking if two arrays are equal
        return true;
      }      
    }
    else if(typeof value1 === 'object') {
      if(_.isEqual(value1, value2)) { // checking if two obj are equal
        return true;
      }      
    }
    else if(value1 == value2) {
      return true;
    }

    return false;
  },

  addDates(val, unit) {
    let date = moment(new Date(), "YYYY-MM-DD");
    date.add(val, unit);
    return date;
  },

  dateRangeOptions() {
    let items = [];
    let today = moment(new Date(), "YYYY-MM-DD");

    items.push({
      type: 1,
      label: 'Yesterday',
      disabled: true,
      start: this.addDates(-1, 'days'),
      end: today
    });

    items.push({
      type: 2,
      label: 'Last 7 days',
      disabled: true,
      start: this.addDates(-6, 'days'),
      end: today,
    });

    items.push({
      type: 3,
      label: 'Last 30 days',
      disabled: true,
      start: this.addDates(-29, 'days'),
      end: today
    });

    items.push({
      type: 4,
      label: 'Last 3 months',
      disabled: true,
      start: this.addDates(-3, 'M'),
      end: today
    });

    items.push({
      type: 5,
      label: 'Year to date',
      disabled: true,
      start: moment(new Date(), "YYYY-MM-DD").startOf('year'),
      end: today
    });

    items.push({
      type: 6,
      // label: 'Last year', OC-1730
      label: 'Last 12 months',
      disabled: true,
      start: this.addDates(-1, 'Y'),
      end: today
    });

    items.push({
      type: -1,
      label: 'Custom',
      disabled: false,
      start: "",
      end: ""
    });

    return items;
  },
  
  filterValues(shareState, dataModel, dateMode) {
    let data = {};

    if(shareState.apiVersion) {
      data.version = shareState.apiVersion;
    }

    let dateStart = dataModel.dateStart;
    let dateEnd = dataModel.dateEnd;      
    if(dateMode == this.MODE_DATE_A && dateStart && dateEnd) {
      let dateStartMoment = moment(dateStart,'YYYY-MM-DD');
      let dateEndMoment = moment(dateEnd,'YYYY-MM-DD');
      let numOfDaysInRange = dateEndMoment.diff(dateStartMoment, 'd')+1
      
      data.dateStart = dateStartMoment.format("YYYY-MM-DD");
      data.dateEnd = dateEndMoment.format("YYYY-MM-DD");
      shareState.dateStart = dateStart;
      shareState.dateEnd = dateEnd;
      
      dataModel.dateRangeInDays = numOfDaysInRange;
      dataModel.dateStartCompare = dateStartMoment.subtract(numOfDaysInRange, 'day').format("YYYY-MM-DD");
      dataModel.dateEndCompare = dateEndMoment.subtract(numOfDaysInRange, 'day').format("YYYY-MM-DD");
    }

    if(dataModel.filters) {
      Object.values(dataModel.filters).forEach(filter => {
        if(!filter.isDisabled && filter.value != null) {
          let filterValue = JSON.parse(JSON.stringify(filter.value));
          let filterValueTo = filter.valueTo ? JSON.parse(JSON.stringify(filter.valueTo)) : null;

          if(filter.type == 'integerRange') {
            data[filter.name] = [filterValue, filterValueTo];
          }
          else if(filter.type == 'timeRange' && (filterValue || filterValueTo)) {
            let timeStart = 0;
            let timeEnd = 0;
            if(filterValue) {
              timeStart = (WyUtils.toInt(filterValue.hh, 0) * 60) + WyUtils.toInt(filterValue.mm, 0) + (WyUtils.toInt(filterValue.ss, 0) / 60)
            }
            if(filterValueTo) {
              timeEnd = (WyUtils.toInt(filterValueTo.hh, 0) * 60) + WyUtils.toInt(filterValueTo.mm, 0) + (WyUtils.toInt(filterValueTo.ss, 0) / 60)
            }
            data[filter.name] = [timeStart, timeEnd];
          }
          else if(filter.name == "sources"){
            let sourceValue = JSON.parse(JSON.stringify(filterValue));
            let index = sourceValue.indexOf('BOT');
            if (index > -1) {
              sourceValue.splice(index, 1);
            }
            data[filter.name] = sourceValue;
          }
          else {
            data[filter.name] = filterValue;
          }
        }
      });
      //set multiple eslect fitlers as [] when select all
      if(data.agentQueues && data.agentQueues.length > 0) {
        if(data.agentQueues.includes('all')) {
          data.agentQueues = data.agentQueues.filter(e => e !== 'all');
        }
        else if(data.agentQueues.includes('')) {
          data.agentQueues.push(null);
        }
      }
      if(data.agentGroups && data.agentGroups.length > 0) {
        if(data.agentGroups.includes('all')) {
          data.agentGroups = data.agentGroups.filter(e => e !== 'all');
        }
        else if(data.agentGroups.includes('')) {
          data.agentGroups.push(null);
        }
      }
      if(data.agentTeams && data.agentTeams.length > 0) {
        if(data.agentTeams.includes('all')) {
          data.agentTeams = data.agentTeams.filter(e => e !== 'all');
        }
        else if(data.agentTeams.includes('')) {
          data.agentTeams.push(null);
        }
      }
      if(data.agentIds && data.agentIds.length > 0) {
        if(data.agentIds.includes('all')) {
          data.agentIds = data.agentIds.filter(e => e !== 'all');
        }
        else if(data.agentIds.includes('')) {
          data.agentIds.push(null);
        }
      }
      if(data.agents && data.agents.length > 0) {
        if(data.agents.includes('all')) {
          data.agents = data.agents.filter(e => e !== 'all');
        }
        else if(data.agents.includes('')) {
          data.agents.push(null);
        }
      }
      if(data.devices && data.devices.length > 0) {
        if(data.devices.includes('all')) {
          data.devices = data.devices.filter(e => e !== 'all');
        }
        else if(data.devices.includes('')) {
          data.devices.push(null);
        }
      }
      if(data.tasks && data.tasks.length > 0) {
        if(data.tasks.includes('all')) {
          data.tasks = data.tasks.filter(e => e !== 'all');
        }
        else if(data.tasks.includes('')) {
          data.tasks.push(null);
        }
      }
      if(data.languages && data.languages.length > 0) {
        if(data.languages.includes('all')) {
          data.languages = data.languages.filter(e => e !== 'all');
        }
        else if(data.languages.includes('')) {
          data.languages.push(null);
        }
      }
      if(data.channels && data.channels.length > 0) {
        if(data.channels.includes('all')) {
          data.channels = data.channels.filter(e => e !== 'all');
        }
        else if(data.channels.includes('')) {
          data.channels.push(null);
        }
      }
      if(data.contactTypes && data.contactTypes.length > 0) {
        if(data.contactTypes.includes('all')) {
          data.contactTypes = data.contactTypes.filter(e => e !== 'all');
        }
        else if(data.contactTypes.includes('')) {
          data.contactTypes.push(null);
        }
      }
    }

    return data;
  },

  setIFrameSelectedFilters(dataModel) {
    const fromFilters = sessionStorage.getItem(WyConstants.CONV_INTELLIGENCE_PROPS_STORAGE_KEY);
    if(fromFilters && fromFilters != "") {
      try {
        const fromFiltersObj = JSON.parse(fromFilters);
        if(fromFiltersObj.dateStart && fromFiltersObj.dateEnd) {
          dataModel.dateCalendar.dateRange.start = fromFiltersObj.dateStart;
          dataModel.dateCalendar.dateRange.end = fromFiltersObj.dateEnd;
          dataModel.dateStart = fromFiltersObj.dateStart;
          dataModel.dateEnd = fromFiltersObj.dateEnd;
        }

        if(fromFiltersObj.languages && fromFiltersObj.languages.length > 0 && dataModel.filters.languages != undefined) {
          dataModel.filters.languages.value = fromFiltersObj.languages;
        }

        if(fromFiltersObj.agentGroups && fromFiltersObj.agentGroups.length > 0 && dataModel.filters.agentGroups != undefined) {
          dataModel.filters.agentGroups.value = fromFiltersObj.agentGroups.map(num => num.toString());
        }

        if(fromFiltersObj.agentTeams && fromFiltersObj.agentTeams.length > 0 && dataModel.filters.agentTeams != undefined) {
          dataModel.filters.agentTeams.value = fromFiltersObj.agentTeams.map(num => num.toString());
        }

        if(fromFiltersObj.agents && fromFiltersObj.agents.length > 0 && dataModel.filters.agents != undefined) {
          dataModel.filters.agents.value = fromFiltersObj.agents.map(num => num.toString());
        }
        
        if(fromFiltersObj.contactTypes && fromFiltersObj.contactTypes.length > 0 && dataModel.filters.contactTypes != undefined) {
          dataModel.filters.contactTypes.value = fromFiltersObj.contactTypes;
        }
        if(fromFiltersObj.channels && fromFiltersObj.channels.length > 0 && dataModel.filters.channels != undefined) {
          dataModel.filters.channels.value = fromFiltersObj.channels;
        }
        if(fromFiltersObj.directions && dataModel.filters.directions != undefined) {
          dataModel.filters.directions.value = fromFiltersObj.directions;
        }
        if(fromFiltersObj.aiFormId && dataModel.filters.formId != undefined) {
          dataModel.filters.formId.value = fromFiltersObj.aiFormId;
        }
        else if(fromFiltersObj.humanFormId && dataModel.filters.formId != undefined) {
          dataModel.filters.formId.value = fromFiltersObj.humanFormId;
        }
      }
      catch(e) {
        console.error(e);
      }
    }
    sessionStorage.removeItem(WyConstants.CONV_INTELLIGENCE_PROPS_STORAGE_KEY);
  }
};

export default WyFilter;